import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.IronyFist,
  voices: {
    main: {
      description:
        "young martial-arts tenor, breath-led focus, upbeat street monk confidence, nimble consonants, warm close mic with light temple-room air",
      seed: 10441,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "一夫当关，万夫莫开！ / Yīfū dāng guān, wàn fū mò kāi! Translation: One man guards the pass, ten thousand men cannot break through!",
      },
      { id: "select_2", text: "The Irony Fist awaits your command." },
      { id: "select_3", text: "Call, and the Irony Fist will answer!" },
      { id: "select_4", text: "Irony Fist, ready to fight!" },
      {
        id: "select_5",
        text: "This is better than the Tournament of the Heavenly Cities!",
      },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "Might as well do a little healing in the midst of all the damage I cause…",
      },
      {
        id: "spawn_2",
        text: "Thanks for the boost, Ami. I promise to put it to good use for our team!",
      },
      {
        id: "spawn_3",
        text: "All right! My fist is feeling stronger than granite!",
      },
      {
        id: "spawn_4",
        text: "With you on my side, Grimm, victory is a sure Thing!",
      },
      {
        id: "spawn_5",
        text: "Wow. The Multiverse really needs its Chi balanced!",
      },
      { id: "spawn_6", text: "What? You were expecting Danny Rand?" },
      {
        id: "spawn_7",
        text: "And I thought the Agents of Atlas were a strange crew…",
      },
      {
        id: "spawn_8",
        text: "K'un-Lun is one of the last standing sanctuaries in my world.",
      },
      { id: "spawn_9", text: "It's every hero for themselves where I'm from." },
      {
        id: "spawn_10",
        text: "Even though it shattered, the Sword of Fu Xi is always with me.",
      },
      {
        id: "spawn_11",
        text: 'I\'m not sure my training is at the "Save the Multiverse" stage yet…',
      },
      {
        id: "spawn_12",
        text: "Even Immortal Weapons need a little help now and then.",
      },
      {
        id: "spawn_13",
        text: "The Dooms are begging for an Irony Fist to their iron faces!",
      },
      {
        id: "spawn_14",
        text: "I'm the sworn protector of K'un-Lun! Who are you?",
      },
      { id: "spawn_15", text: "My power is a gift from Shou-Lao the Undying!" },
      {
        id: "spawn_16",
        text: "I used to be a Sword Master, but now, I'm so much more.",
      },
      {
        id: "spawn_17",
        text: "Immortality comes with a price, but I was glad to pay it!",
      },
      {
        id: "spawn_18",
        text: "There were lots of Irony Fists before me, but I'll be the best.",
      },
      {
        id: "spawn_19",
        text: "You know my legacy, but this is a whole new chapter!",
      },
      {
        id: "spawn_20",
        text: "This is better than the Tournament of the Heavenly Cities!",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "Immortality has its perks." },
      { id: "respawn_2", text: "Shou-Lao has blessed me again!" },
      { id: "respawn_3", text: "I rise in the name of K'un-Lun!" },
      { id: "respawn_4", text: "The Irony Fist still burns!" },
      { id: "respawn_5", text: "You'll fall long before I do." },
    ],
    ult_ally: [{ id: "ult_ally", text: "The Dragon Unleashed!" }],
    ult_enemy: [
      {
        id: "ult_enemy_1",
        text: "气贯长虹！ / Qì guàn cháng hóng! Translation: My Chi will pierce the rainbow!",
      },
      {
        id: "ult_enemy_2",
        text: "哈哈，恭喜发财！/ Haha, gōngxǐ fācái! (Lion's Gaze skin-exclusive) Translation: Haha, wishing you prosperity!",
      },
    ],
    ability2: [
      {
        id: "ability2_1",
        text: "抱元守一！ / Bào yuán shǒu yī! Translation: Embrace the origin and guard the unity!",
      },
      { id: "ability2_2", text: "Bless me, Shou-Lao." },
      { id: "ability2_3", text: "Time to heal." },
    ],
    ability1: [
      {
        id: "ability1_1",
        text: "朝面追形！ / Cháo miàn zhuī xíng! Translation: Face the form and pursue it!",
      },
      { id: "ability1_2", text: "Dragon Kick!" },
      { id: "ability1_3", text: "Shou-Lao's Fury!" },
    ],
    kill: [
      { id: "kill_1", text: "Defeat was your destiny." },
      { id: "kill_2", text: "This fight was never yours to win." },
      { id: "kill_3", text: "You were always outmatched." },
      { id: "kill_4", text: "Far from legendary…" },
      { id: "kill_5", text: "You fought with honor. Eh, kinda." },
    ],
    multikill: [
      { id: "multikill_1", text: "Three enemies down." },
      { id: "multikill_2", text: "That makes three." },
      { id: "multikill_3", text: "三个！ / Sān gè! Translation: Three!" },
      { id: "multikill_4", text: "Five!" },
      { id: "multikill_5", text: "That's five of them!" },
      { id: "multikill_6", text: "五个！ / Wǔ gè! Translation: Five!" },
      { id: "multikill_7", text: "I've taken them all out!" },
      { id: "multikill_8", text: "My fist is unrivalled!" },
      { id: "multikill_9", text: "Was that all of 'em?" },
    ],
    low_hp: [
      { id: "low_hp_1", text: "That was badly needed." },
      { id: "low_hp_2", text: "My health is back." },
    ],
    healed: [
      { id: "healed_1", text: "Healed at last!" },
      { id: "healed_2", text: "Whew. Almost bowed out!" },
      { id: "healed_3", text: "Health. Not bad." },
      { id: "healed_4", text: "I could use this." },
    ],
  },
} satisfies VoiceScript;

export default script;
